module.exports = __webpack_public_path__ + "img/skin_active_menu_type_block.c8a27db1.png";